// extracted by css-extract-rspack-plugin
export default {"yellow":"yellow-PfhNoM","body":"body-siEGue","pic":"pic-Xu6kHp"};